
export const allTimezones = {
  "Pacific/Midway": "(UTC+13:00) Midway Island, Samoa",
  "Pacific/Honolulu": "(UTC-10:00) Hawaii",
  "America/Juneau": "(UTC-09:00) Alaska",
  "America/Boise": "(UTC-07:00) Mountain Time",
  "America/Dawson": "(UTC-07:00) Dawson, Yukon",
  "America/Chihuahua": "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  "America/Phoenix": "(UTC-07:00) Arizona",
  "America/Chicago": "(UTC-06:00) Central Time (US & Canada)",
  "America/Regina": "(UTC-06:00) Saskatchewan",
  "America/Mexico_City": "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  "America/Belize": "(UTC-06:00) Central America",
  "America/Detroit": "(UTC-05:00) Eastern Time",
  "America/Bogota": "(UTC-05:00) Bogota, Lima, Quito",
  "America/Caracas": "(UTC-04:30) Caracas, La Paz",
  "America/Santiago": "(UTC-04:00) Santiago",
  "America/St_Johns": "(UTC-03:30) Newfoundland and Labrador",
  "America/Sao_Paulo": "(UTC-03:00) Brasilia",
  "America/Tijuana": "(UTC-07:00) Tijuana",
  "America/Montevideo": "(UTC-03:00) Montevideo",
  "America/Argentina/Buenos_Aires": "(UTC-03:00) Buenos Aires, Georgetown",
  "America/Godthab": "(UTC-03:00) Greenland",
  "America/Los_Angeles": "(UTC-07:00) Pacific Time",
  "Atlantic/Azores": "(UTC-01:00) Azores",
  "Atlantic/Cape_Verde": "(UTC-01:00) Cape Verde Islands",
  "GMT": "UTC",
  "Europe/London": "(UTC) Edinburgh, London",
  "Europe/Dublin": "(UTC) Dublin",
  "Europe/Lisbon": "(UTC) Lisbon",
  "Africa/Casablanca": "(UTC) Casablanca, Monrovia",
  "Atlantic/Canary": "(UTC) Canary Islands",
  "Europe/Belgrade": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  "Europe/Sarajevo": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  "Europe/Brussels": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  "Europe/Amsterdam": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  "Africa/Algiers": "(UTC+01:00) West Central Africa",
  "Europe/Bucharest": "(UTC+02:00) Bucharest",
  "Africa/Cairo": "(UTC+02:00) Cairo",
  "Europe/Helsinki": "(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
  "Europe/Athens": "(UTC+03:00) Athens, Minsk",
  "Asia/Jerusalem": "(UTC+02:00) Jerusalem",
  "Africa/Harare": "(UTC+02:00) Harare, Pretoria",
  "Europe/Moscow": "(UTC+03:00) Istanbul, Moscow, St. Petersburg, Volgograd",
  "Asia/Kuwait": "(UTC+03:00) Kuwait, Riyadh",
  "Africa/Nairobi": "(UTC+03:00) Nairobi",
  "Asia/Baghdad": "(UTC+03:00) Baghdad",
  "Asia/Tehran": "(UTC+03:30) Tehran",
  "Asia/Dubai": "(UTC+04:00) Abu Dhabi, Muscat",
  "Asia/Baku": "(UTC+04:00) Baku, Tbilisi, Yerevan",
  "Asia/Kabul": "(UTC+04:30) Kabul",
  "Asia/Yekaterinburg": "(UTC+05:00) Ekaterinburg",
  "Asia/Karachi": "(UTC+05:00) Islamabad, Karachi, Tashkent",
  "Asia/Kolkata": "Chennai, Kolkata, Mumbai, New Delhi",
  "Asia/Kathmandu": "(UTC+05:30) Kathmandu",
  "Asia/Dhaka": "(UTC+06:00) Astana, Dhaka",
  "Asia/Colombo": "(UTC+05:30) Sri Jayawardenepura",
  "Asia/Almaty": "(UTC+06:00) Nur-Sultan (Astana)",
  "Asia/Novosibirsk": "(UTC+07:00) Novosibirsk",
  "Asia/Rangoon": "(UTC+06:30) Yangon (Rangoon)",
  "Asia/Bangkok": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  "Asia/Krasnoyarsk": "(UTC+08:00) Krasnoyarsk",
  "Asia/Shanghai": "(UTC+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi",
  "Asia/Kuala_Lumpur": "(UTC+08:00) Kuala Lumpur, Singapore",
  "Asia/Taipei": "(UTC+08:00) Taipei",
  "Australia/Perth": "(UTC+08:00) Perth",
  "Asia/Irkutsk": "(UTC+08:00) Irkutsk, Ulaanbaatar",
  "Asia/Seoul": "(UTC+09:00) Seoul",
  "Asia/Tokyo": "(UTC+09:00) Osaka, Sapporo, Tokyo",
  "Asia/Yakutsk": "(UTC+09:00) Yakutsk",
  "Australia/Darwin": "(UTC+09:30) Darwin",
  "Australia/Adelaide": "(UTC+09:30) Adelaide",
  "Australia/Sydney": "(UTC+10:00) Canberra, Melbourne, Sydney",
  "Australia/Brisbane": "(UTC+10:00) Brisbane",
  "Australia/Hobart": "(UTC+10:00) Hobart",
  "Asia/Vladivostok": "(UTC+11:00) Vladivostok",
  "Pacific/Guam": "(UTC+10:00) Guam, Port Moresby",
  "Asia/Magadan": "(UTC+12:00) Magadan, Solomon Islands, New Caledonia",
  "Asia/Kamchatka": "(UTC+12:00) Kamchatka, Marshall Islands",
  "Pacific/Fiji": "(UTC+12:00) Fiji Islands",
  "Pacific/Auckland": "(UTC+12:00) Auckland, Wellington",
  "Pacific/Tongatapu": "(UTC+13:00) Nuku'alofa",
}
